/**
 * PaymentLocation
 * Auto-generated enum from C#
 */

export type PaymentLocation = 1 | 2 | 3;

export const PaymentLocation = {
    ORIGEN: 1 as PaymentLocation,
    DESTINO: 2 as PaymentLocation,
    CUENTA: 3 as PaymentLocation
};
